export default __webpack_public_path__ + "static/media/3icon.9ee72685.svg";